export const config = {
  colors: [
    "draft-500",
    "leave-500",
    "primary-500",
    "success-500",
    "danger-500",
    "info-500",
    "warning-500",
    "invoiced-500",
    // "emerald-500",
    // "orange-500",
    // "lime-500",
    // "indigo-500",
    // "amber-500",
    // "fuchsia-500",
    // "teal-500",
  ],
  projection: {
    show: true,
    color: "gray-600",
    dasharray: "3 3",
    strokeWidth: 0.5,
    curve: "straight", //"straight" | "smooth" | "stepline"
    lineCap: "round",
    area: {
      show: true,
      fill: { type: "solid", opacity: 0.1 },
    },
  },

  padding: { top: 15, right: 5, bottom: 4, left: 20 },
  axis: {
    color: "gray-500",
    labelColor: "gray-600",
    edgePadding: 50,
    fontSize: 11,
    scroll: "auto",
    y: {
      //labelTitle: "This is the serrring",
      clampMinZero: false,
      format: "compact", // optional: 'compact' for 1K, 1M//
      decimals: false, // optional: decimals if needed
      width: 30,
    },
    x: {
      //  labelTitle: "Months",
      clampMinZero: false,
      format: "compact", // optional: 'compact' for 1K, 1M//
      decimals: false, // optional: decimals if needed
      height: 20,
    },
  },
  grid: {
    color: "gray-300",
    dasharray: "5 5",
    strokeWidth: 1,
    horizontal: true,
    vertical: true,
    background: "transparent",
  },
  legend: {
    show: true,
    mode: "inline", // "inline" | "select"
    maxHeight: 160,
    showSearch: true,
    searchPlaceholder: "Search",
  },
  data: {
    prefix: "",
    suffix: "",
    //format: "compact", // optional: 'compact' for 1K, 1M//
  },
  showLabels: {
    show: false,
    valueDisplay: "value", //value, percentage
    colorMode: "series", //series, single
    color: "red-500",
    bg: "transparent",
    borderColor: "transparent",
    borderWidth: 0.5,
    paddingX: 5,
    paddingY: 2,
    radius: 4,
    fontSize: 10,
  },
  background: "transparent",
  // animations: {
  //   enabled: true,
  //   duration: 600,
  //   inView: {
  //     enabled: true,
  //     amount: 0.2,
  //     once: true,
  //     initialY: 24,
  //     initialOpacity: 0,
  //   },
  //   data: {
  //     enabled: true,
  //     duration: 600,
  //     stagger: 0.02,
  //   },
  // },
  dateConfig: {
    dateFilter: false,
    dateRange: { from: null, to: null },
    defaultOption: "",
    onChange: null,
  },
  seriesFilter: {
    showFilter: false,
    title: "Series",
    seriesNameKey: "seriesName",
    showSearch: true,
    searchPlaceholder: "Filter Series",
  },
  toggleChart: {
    showToggle: false,
    toggleList: [],
  },
  decimate: { enabled: true, targetPointsPerPixel: 1.0, minPoints: 200 },

  noDataConfig: {
    show: false,
    title: "No Data1",
    desc: "Looks like you don't have any data to view.asd fsdfkl jasd;fjkasdlkf a;sldfj laksd ",
    color: "primary",
    noImage: false,
  },
};

export const lineConfig = {
  line: {
    stroke: {
      width: 2, //number or array per series
      curve: "straight", //"straight" | "smooth" | "stepline"
      //dashArray: "4 4", //number or array per series; converts to "n n" pattern when n > 0
      lineCap: "round", //butt| "round" | "square"
    },
    markers: { size: 4 },
    area: {
      show: false,
      fill: { type: "solid", opacity: 0.5 }, //fill: { type: "solid", color: "#3b82f6", opacity: 0.25 }
    },
  },
  minStepX: 100,
  groupConfig: {
    orientation: "byCategory",
    flatten: "inner",
    aggregateAcrossGroups: "sum",
  },
};

export const columnConfig = {
  stacked: false,
  radius: 0,
  width: 20,
  gap: 2,
  groupGap: 100,
  grouped: {
    orientation: "byCategory",
    flatten: "groupStacked",
  },
};

export const barConfig = {
  stacked: false, // for both bar and column
  radius: 0,
  height: 20, // fixed bar height
  gap: 2, // fixed gap between series within a category
  groupGap: 100, // fixed gap between categories
  grouped: {
    orientation: "byCategory",
    flatten: "groupStacked",
  },
};

export const pieConfig = {
  pie: {
    innerRatio: 0.4,
    padAngleDeg: 0,
    gap: 0,
    borderWidth: 0,
    borderColor: "transparent",
    infoSection: {
      show: false,
    },
    groupConfig: {
      orientation: "byCategory",
      flatten: "inner",
      aggregateAcrossGroups: "sum",
    },
  },
};
export const tableConfig = {
  tableId: "chart_table_default",
  hideToolBar: true,
  showPages: true,
  showSlNo: false,
  showCheckbox: false,
  fixedCol: 1,
  totalText: "Total",
  showTotalRow: false,
  toolbarRight: {
    search: false,
    filter: false,
    download: false,
    viewToggle: false,
    order: ["search", "filter", "download", "viewToggle", "add"],
  },
  toolbarLeft: { add: [] },
  columns: [
    // { key: "category", label: "Duration", width: 260, dataType: "string" },
    // {
    //   key: "group",
    //   label: "Employee",
    //   width: 180,
    //   dataType: "string",
    // },
    // { key: "__rowClass", label: "", hide: true, getRowClass: (row) => "" },
  ],
  grouped: {
    orientation: "byCategory",
    flatten: "groupStacked",
  },
};
